import { replaceImageVaultBasePath } from "@utils/urlResolver";

import { FileBlockUrls } from "types/FileBlockDataType";

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getFileImageUrls = (thumbnailImage: any, file: any): FileBlockUrls => {
  const size375 = thumbnailImage?.Size375webP
    ? replaceImageVaultBasePath(thumbnailImage?.Size375webP)
    : thumbnailImage?.Size375
      ? replaceImageVaultBasePath(thumbnailImage?.Size375)
      : file?.Size375
        ? replaceImageVaultBasePath(file?.Size375)
        : null;

  const size768 = thumbnailImage?.Size768webP
    ? replaceImageVaultBasePath(thumbnailImage?.Size768webP)
    : thumbnailImage?.Size768
      ? replaceImageVaultBasePath(thumbnailImage?.Size768)
      : null;

  const original = thumbnailImage?.mediaUrl
    ? replaceImageVaultBasePath(thumbnailImage?.mediaUrl)
    : file?.mediaUrl
      ? replaceImageVaultBasePath(file?.thumbUrl)
      : null;

  const size180 = file?.Size180 ? replaceImageVaultBasePath(file?.Size180) : null;
  const size240 = file?.Size240 ? replaceImageVaultBasePath(file?.Size240) : null;
  const size480 = file?.Size480 ? replaceImageVaultBasePath(file?.Size480) : null;

  const urls = {} as FileBlockUrls;
  if (original) urls.original = original;
  if (size180) urls.size180 = size180;
  if (size240) urls.size240 = size240;
  if (size375) urls.size375 = size375;
  if (size480) urls.size480 = size480;
  if (size768) urls.size768 = size768;
  return urls;
};
